import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import Menu from '../components/Menu'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -2%;
  margin-bottom: auto;

  @media only screen and (max-width: 768px) {
    padding: 0 15px;
  }
`

const Logo = styled.img`
  width: 220px;
`

const Header = () => {
  return (
    <Wrapper>
      <NavLink to="/"><Logo src={`${process.env.PUBLIC_URL}/logo.png`} height="51" width="220" /></NavLink>
      <Menu />
    </Wrapper>
  )
}

export default Header
